import '../../modules/mode-components';

import * as angular from 'angular';

/**
 * @deprecated Prefer the `AutofocusDirective`
 */
const focusMe = function ($timeout) {
  return {
    scope: {
      focusObserver: '=?',
    },

    link: function (scope: angular.IScope, element, attr) {
      if (attr.focusObserver) {
        scope.$watch('focusObserver', function (value) {
          if (typeof value === 'boolean' && value) {
            $timeout(
              function () {
                element.focus().select();
              },
              0,
              false
            );
          }
        });
      } else {
        $timeout(
          function () {
            element.focus().select();
          },
          0,
          false
        );
      }
    },
  };
};

focusMe.$inject = ['$timeout'];

angular.module('mode.components').directive('focusMe', focusMe);
